function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M34.5 2.556c17.642 0 31.944 14.302 31.944 31.944S52.142 66.444 34.5 66.444 2.556 52.142 2.556 34.5 16.858 2.556 34.5 2.556zm-.035 22.062c-5.439 0-9.847 4.408-9.847 9.847 0 5.438 4.408 9.847 9.847 9.847a9.847 9.847 0 009.847-9.847c0-5.439-4.409-9.847-9.847-9.847z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF7D00",
  d: "M34.5 20.444c7.763 0 14.056 6.293 14.056 14.056 0 7.763-6.293 14.056-14.056 14.056-7.763 0-14.056-6.293-14.056-14.056 0-7.763 6.293-14.056 14.056-14.056zm-.035 6.636a7.385 7.385 0 100 14.77 7.385 7.385 0 000-14.77z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M34.465 0C15.43 0 0 15.43 0 34.465 0 53.499 15.43 68.93 34.465 68.93c19.034 0 34.465-15.43 34.465-34.465A34.465 34.465 0 0034.465 0zm0 64.006c-16.315 0-29.541-13.226-29.541-29.541 0-16.315 13.226-29.541 29.54-29.541 16.316 0 29.542 13.226 29.542 29.54a29.541 29.541 0 01-29.541 29.542z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M34.465 19.694c-8.158 0-14.77 6.613-14.77 14.77 0 8.158 6.612 14.771 14.77 14.771 8.157 0 14.77-6.613 14.77-14.77 0-8.158-6.613-14.77-14.77-14.77zm0 24.618c-5.439 0-9.847-4.409-9.847-9.847 0-5.439 4.408-9.847 9.847-9.847 5.438 0 9.847 4.408 9.847 9.847a9.847 9.847 0 01-9.847 9.847z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M34.465 27.08a7.385 7.385 0 100 14.77 7.385 7.385 0 000-14.77zm0 12.308a4.924 4.924 0 110-9.847 4.924 4.924 0 010 9.847z"
}));

var SvgWheel = function SvgWheel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 69",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWheel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wheel.2e76768c.svg";
export { ForwardRef as ReactComponent };